import {BaseConfig} from "../../../../infrastructure/config/base-config";
import {MatchEventsModuleTerms} from "./match-events-module.terms";

export class MatchEventsModuleConfig extends BaseConfig {

  static injectables = [MatchEventsModuleTerms];

  constructor(terms: MatchEventsModuleTerms) {
    super('matchEventsModule', null, terms);
  }
}
